import { inject } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { map, switchMap } from 'rxjs/operators';

export const RoleGuard: CanActivateFn = (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  // Check if the user is authenticated
  return authService.isAuthenticated$.pipe(
    switchMap((isValid) => {
      if (!isValid) {
        authService.logout(); // Log out the user if session expired
        router.navigate(['/']); // Redirect to home page
        return [false]; // Return false to block navigation
      }
      // If authenticated, check for role-based access
      const expectedRoles = (route.data['roles'] as string[]) || [];
      return authService.getUserGroups().pipe(
        map((groups) => {
          const hasRole = expectedRoles.some((role) => groups.includes(role));
          if (!hasRole) {
            router.navigate(['/']); // Redirect to home page if no role matches
            return false;
          }
          return true; // Allow navigation if roles match
        })
      );
    })
  );
};
